export default {
    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/account-managers' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
}